export { ContactDetailsFilter, ContactDetailsFilterProps } from './ContactDetailsFilter';
